import type { WhenDto } from "../../../../../types/resolver";

/**
 * Which top-level When rule shape is active. Structural rules must be detected before `true`,
 * because API payloads may include `"true": null` alongside real rules (Jackson / OpenAPI),
 * and `null !== undefined` would incorrectly classify the tree as "always true".
 */
export function getWhenRuleType(w: WhenDto | null | undefined): string {
    if (!w) return "true";
    if (w.all) return "all";
    if (w.any) return "any";
    if (w.not) return "not";
    if (w.eq) return "eq";
    if (w.ne) return "ne";
    if (w.in) return "in";
    if (w.startsWith) return "startsWith";
    if (w.endsWith) return "endsWith";
    if (w.contains) return "contains";
    if (w.gt) return "gt";
    if (w.gte) return "gte";
    if (w.lt) return "lt";
    if (w.lte) return "lte";
    if (w.anyMatch) return "anyMatch";
    if (w.noneMatch) return "noneMatch";
    if (w.allMatch) return "allMatch";
    if (w.true === true) return "true";
    return "true";
}
